import _ from 'lodash';
/* eslint-disable func-names */
/* eslint-disable comma-dangle */

const getRandomFormat = (name) => {
  return {
    label: name,
    backgroundColor: '#d1d1e0',
    hoverBackgroundColor: '#8686ac'
  };
};

const chartFormatStatus = [
  {
    label: 'Active',
    // lighter green
    backgroundColor: '#87CD5C',
    hoverBackgroundColor: '#72AC4F',
  },
  {
    label: 'Out Of Service',
    // teal blue
    backgroundColor: '#17a2b8',
    hoverBackgroundColor: '#017771',
  },
  {
    label: 'Stored',
    // yellow
    backgroundColor: '#FFCE56',
    hoverBackgroundColor: '#E0AB0B',
  },
  {
    label: 'Inactive',
    // purple
    backgroundColor: '#9D03A6',
    hoverBackgroundColor: '#73017A',
  }
];

export default {
  getStatusChartData: function(actual_data) {
    const ourChartData = _.map(actual_data, function(a) {
      let format = _.find(chartFormatStatus, function(f){
        return f.label === a.label;
      });
      if (format === undefined) {
        format = getRandomFormat(a.label);
      }
      return { ...format, data: a.value};
    });
    const formatting = {
      labels: _.map(ourChartData, x => x.label),
      datasets: [{
        data: _.map(ourChartData, x => x.data),
        backgroundColor: _.map(ourChartData, x => x.backgroundColor),
        hoverBackgroundColor: _.map(ourChartData, x => x.hoverBackgroundColor),
      }],
    };
    return formatting;
  },

  chartOptions: function() {

    return {
      responsive: true,
      tooltips: {
        mode: 'label',
      },
      elements: {
        line: {
          fill: false,
          lineTension: 0,
        },
      },
      legend: {
        display: false,
      },
      scales: {
        yAxes: [{
          display: true,
          ticks: {
            beginAtZero: true,
            stepSize: 1,
            min: 0,
            max: 20
          }
        }]
      }
    }
  },

  getListOfRandomHexColors: function (desiredAmount = 1, returnString = false) {
    let listOfColors = [];
    for (let i = 1; i < desiredAmount; i++) {
      listOfColors.push(`#${Math.floor(Math.random() * 16777215).toString(16)}`);
    }
    return returnString ? listOfColors[0] : listOfColors;
  }
}


// WEBPACK FOOTER //
// ./src/helpers/chartHelper.js